import React, { useState } from "react";
import { Container, Row, Col, Card, CardBody, Modal, ModalBody, ModalFooter, Button, FormFeedback } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

import moment from 'moment';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';


const Property = props => {
  //meta title
  document.title = "Property";
	const location = useLocation();
  const { getRequest, postRequest } = useRequests();
  

  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      p_id: '',
      status: '',
    },
    validationSchema: Yup.object({
      status: Yup.string().required('Please select status'),
    }),
    onSubmit: async (values) => {
      try {
        let submit1 = document.getElementById('submit1');
        submit1.disabled = true;
        submit1.textContent = 'Processing...';

        const jsonpar = JSON.stringify({
          p_id: values.p_id,
          status: values.status
        });
        const res = await postRequest('update-property-status', jsonpar);
        if (res && res.code === 200) {
          handleLoadGetProperties();

          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'success',
            message: res.message,
          }));
        }
        else {
          setAlertData((AlertData) => ({
            ...AlertData,
            variant: 'error',
            message: res.message,
          }));
        }
        resetAlertData();

        submit1.disabled = false;
        submit1.textContent = 'Update';

        setStandardModal1(false);
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const [StandardModal1, setStandardModal1] = React.useState(false);
  const togStandardModal1 = async (elementData) => {
    validation1.setValues({
      ...validation1.values,
      p_id: elementData.p_id,
      status: elementData.status,
    });
    setStandardModal1(true);
  }

  const [PropertiesTBody, setPropertiesTBody] = React.useState('');
  const handleT1Body = async (tempData) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{element.property_name}</td>
        <td>{moment(element.created_at).format('YYYY-MM-DD | HH:mm')}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Enable' ? 'badge-soft-success' : 'badge-soft-danger')}>{element.status}</span></td>
        <td className="text-center">
          <div className="centerLink">
            <Link title="Edit Status" to="#" className="font-size-14 bg-primary edit-box" onClick={(e)=>togStandardModal1(element)}><i className="bx bx-cog"></i></Link>
            <Link title="Edit Property" to={"/edit_property/" + btoa(element.p_id)} className="font-size-14 bg-primary edit-box"><i className="bx bxs-edit"></i></Link>
            <Link title="Property Documents" to={"/property_documents/" + btoa(element.p_id)} className="font-size-14 bg-primary edit-box"><i className="bx bxs-file-doc"></i></Link>
            <Link title="Team" to={"/team/" + btoa(element.p_id)} className="font-size-14 bg-primary edit-box"><i className="fas fa-people-arrows"></i></Link>
          </div>
        </td>
      </tr>
    ));

    setPropertiesTBody(tempTBody);
  }
  const handleLoadGetProperties = async () => {
    const res = await getRequest('get-properties');
    if (res && res.code === 200) {
      let originalText = res.data;

      handleT1Body(originalText);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="5" className="text-center">No records found</td>
                      </tr>);

      setPropertiesTBody(tempTBody);


      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  React.useEffect(() => {
    handleLoadGetProperties();

    if (typeof location.state !== 'undefined' && typeof location.state.message !== 'undefined') {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: location.state.status,
        message: location.state.message,
      }));
      resetAlertData();
		}
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={props.t("Eshepay")} breadcrumbItem={props.t("Properties")} />

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div className="table-responsive">
                      <table className="table table-hover table-highlight" style={{ minWidth: '800px' }}>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Property name</th>
                            <th>Date</th>
                            <th>Status</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {PropertiesTBody}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal isOpen={StandardModal1} backdrop={'static'} centered className="transation">
        <div>
          <div className="modal-header">
            <h5 className="modal-title mt-0">Change Status</h5>
            <button type="button" onClick={(e)=>setStandardModal1(false)} className="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <ModalBody>
            <div className="mb-3">
              <label className="form-label">Select Status :</label>
              <select className="form-select" name="status" value={validation1.values.status} onChange={(e) => validation1.setValues({ ...validation1.values, status: e.target.value })}>
                <option value="Enable">Enable</option>
                <option value="Disable">Disable</option>
              </select>
              {validation1.touched.status && validation1.errors.status ? (
                <FormFeedback type="invalid">{validation1.errors.status}</FormFeedback>
              ) : null}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button 
              id="submit1"
              onClick={(e) => {
                e.preventDefault();
                validation1.handleSubmit();
                return false;
              }}
            type="button" color="primary" >Update</Button>
            <Button type="button" color="light" onClick={(e)=>setStandardModal1(false)} >Cancel</Button>
          </ModalFooter>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default withTranslation()(Property);
